<canvas #gradientCanvas width="2500" height="1600"></canvas>